// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/organisations/organisation.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { EmptyRequest, EmptyResponse } from "../../common/messages/messages";

export const protobufPackage = "services.organisations";

export interface Organisation {
  name: string;
  address: string;
  manager: string;
  parentOrganisation?: string | undefined;
  nameTranslations: { [key: string]: string };
  location: GeoCoordinate | undefined;
  properties: { [key: string]: boolean };
  timezone: string;
  additionalData: { [key: string]: string };
}

export interface Organisation_NameTranslationsEntry {
  key: string;
  value: string;
}

export interface Organisation_PropertiesEntry {
  key: string;
  value: boolean;
}

export interface Organisation_AdditionalDataEntry {
  key: string;
  value: string;
}

export interface GeoCoordinate {
  latitude: number;
  longitude: number;
}

export interface GetAllOrganisationsResponse {
  organisations: Organisation[];
}

function createBaseOrganisation(): Organisation {
  return {
    name: "",
    address: "",
    manager: "",
    parentOrganisation: undefined,
    nameTranslations: {},
    location: undefined,
    properties: {},
    timezone: "",
    additionalData: {},
  };
}

export const Organisation: MessageFns<Organisation> = {
  encode(message: Organisation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.manager !== "") {
      writer.uint32(26).string(message.manager);
    }
    if (message.parentOrganisation !== undefined) {
      writer.uint32(34).string(message.parentOrganisation);
    }
    globalThis.Object.entries(message.nameTranslations).forEach(([key, value]: [string, string]) => {
      Organisation_NameTranslationsEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    if (message.location !== undefined) {
      GeoCoordinate.encode(message.location, writer.uint32(50).fork()).join();
    }
    globalThis.Object.entries(message.properties).forEach(([key, value]: [string, boolean]) => {
      Organisation_PropertiesEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    if (message.timezone !== "") {
      writer.uint32(66).string(message.timezone);
    }
    globalThis.Object.entries(message.additionalData).forEach(([key, value]: [string, string]) => {
      Organisation_AdditionalDataEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Organisation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganisation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.manager = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentOrganisation = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = Organisation_NameTranslationsEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.nameTranslations[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.location = GeoCoordinate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = Organisation_PropertiesEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.properties[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.timezone = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = Organisation_AdditionalDataEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.additionalData[entry9.key] = entry9.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Organisation {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      manager: isSet(object.manager) ? globalThis.String(object.manager) : "",
      parentOrganisation: isSet(object.parentOrganisation)
        ? globalThis.String(object.parentOrganisation)
        : isSet(object.parent_organisation)
        ? globalThis.String(object.parent_organisation)
        : undefined,
      nameTranslations: isObject(object.nameTranslations)
        ? (globalThis.Object.entries(object.nameTranslations) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.name_translations)
        ? (globalThis.Object.entries(object.name_translations) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      location: isSet(object.location) ? GeoCoordinate.fromJSON(object.location) : undefined,
      properties: isObject(object.properties)
        ? (globalThis.Object.entries(object.properties) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
      additionalData: isObject(object.additionalData)
        ? (globalThis.Object.entries(object.additionalData) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.additional_data)
        ? (globalThis.Object.entries(object.additional_data) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: Organisation): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.manager !== "") {
      obj.manager = message.manager;
    }
    if (message.parentOrganisation !== undefined) {
      obj.parentOrganisation = message.parentOrganisation;
    }
    if (message.nameTranslations) {
      const entries = globalThis.Object.entries(message.nameTranslations) as [string, string][];
      if (entries.length > 0) {
        obj.nameTranslations = {};
        entries.forEach(([k, v]) => {
          obj.nameTranslations[k] = v;
        });
      }
    }
    if (message.location !== undefined) {
      obj.location = GeoCoordinate.toJSON(message.location);
    }
    if (message.properties) {
      const entries = globalThis.Object.entries(message.properties) as [string, boolean][];
      if (entries.length > 0) {
        obj.properties = {};
        entries.forEach(([k, v]) => {
          obj.properties[k] = v;
        });
      }
    }
    if (message.timezone !== "") {
      obj.timezone = message.timezone;
    }
    if (message.additionalData) {
      const entries = globalThis.Object.entries(message.additionalData) as [string, string][];
      if (entries.length > 0) {
        obj.additionalData = {};
        entries.forEach(([k, v]) => {
          obj.additionalData[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Organisation>, I>>(base?: I): Organisation {
    return Organisation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Organisation>, I>>(object: I): Organisation {
    const message = createBaseOrganisation();
    message.name = object.name ?? "";
    message.address = object.address ?? "";
    message.manager = object.manager ?? "";
    message.parentOrganisation = object.parentOrganisation ?? undefined;
    message.nameTranslations = (globalThis.Object.entries(object.nameTranslations ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.location = (object.location !== undefined && object.location !== null)
      ? GeoCoordinate.fromPartial(object.location)
      : undefined;
    message.properties = (globalThis.Object.entries(object.properties ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.timezone = object.timezone ?? "";
    message.additionalData = (globalThis.Object.entries(object.additionalData ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseOrganisation_NameTranslationsEntry(): Organisation_NameTranslationsEntry {
  return { key: "", value: "" };
}

export const Organisation_NameTranslationsEntry: MessageFns<Organisation_NameTranslationsEntry> = {
  encode(message: Organisation_NameTranslationsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Organisation_NameTranslationsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganisation_NameTranslationsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Organisation_NameTranslationsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: Organisation_NameTranslationsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Organisation_NameTranslationsEntry>, I>>(
    base?: I,
  ): Organisation_NameTranslationsEntry {
    return Organisation_NameTranslationsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Organisation_NameTranslationsEntry>, I>>(
    object: I,
  ): Organisation_NameTranslationsEntry {
    const message = createBaseOrganisation_NameTranslationsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseOrganisation_PropertiesEntry(): Organisation_PropertiesEntry {
  return { key: "", value: false };
}

export const Organisation_PropertiesEntry: MessageFns<Organisation_PropertiesEntry> = {
  encode(message: Organisation_PropertiesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Organisation_PropertiesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganisation_PropertiesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Organisation_PropertiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: Organisation_PropertiesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Organisation_PropertiesEntry>, I>>(base?: I): Organisation_PropertiesEntry {
    return Organisation_PropertiesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Organisation_PropertiesEntry>, I>>(object: I): Organisation_PropertiesEntry {
    const message = createBaseOrganisation_PropertiesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseOrganisation_AdditionalDataEntry(): Organisation_AdditionalDataEntry {
  return { key: "", value: "" };
}

export const Organisation_AdditionalDataEntry: MessageFns<Organisation_AdditionalDataEntry> = {
  encode(message: Organisation_AdditionalDataEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Organisation_AdditionalDataEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganisation_AdditionalDataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Organisation_AdditionalDataEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: Organisation_AdditionalDataEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Organisation_AdditionalDataEntry>, I>>(
    base?: I,
  ): Organisation_AdditionalDataEntry {
    return Organisation_AdditionalDataEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Organisation_AdditionalDataEntry>, I>>(
    object: I,
  ): Organisation_AdditionalDataEntry {
    const message = createBaseOrganisation_AdditionalDataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseGeoCoordinate(): GeoCoordinate {
  return { latitude: 0, longitude: 0 };
}

export const GeoCoordinate: MessageFns<GeoCoordinate> = {
  encode(message: GeoCoordinate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GeoCoordinate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeoCoordinate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeoCoordinate {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: GeoCoordinate): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeoCoordinate>, I>>(base?: I): GeoCoordinate {
    return GeoCoordinate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeoCoordinate>, I>>(object: I): GeoCoordinate {
    const message = createBaseGeoCoordinate();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseGetAllOrganisationsResponse(): GetAllOrganisationsResponse {
  return { organisations: [] };
}

export const GetAllOrganisationsResponse: MessageFns<GetAllOrganisationsResponse> = {
  encode(message: GetAllOrganisationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.organisations) {
      Organisation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllOrganisationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllOrganisationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organisations.push(Organisation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllOrganisationsResponse {
    return {
      organisations: globalThis.Array.isArray(object?.organisations)
        ? object.organisations.map((e: any) => Organisation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAllOrganisationsResponse): unknown {
    const obj: any = {};
    if (message.organisations?.length) {
      obj.organisations = message.organisations.map((e) => Organisation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllOrganisationsResponse>, I>>(base?: I): GetAllOrganisationsResponse {
    return GetAllOrganisationsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllOrganisationsResponse>, I>>(object: I): GetAllOrganisationsResponse {
    const message = createBaseGetAllOrganisationsResponse();
    message.organisations = object.organisations?.map((e) => Organisation.fromPartial(e)) || [];
    return message;
  },
};

export interface OrganisationService {
  getAllOrganisations(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetAllOrganisationsResponse>;
  updateOrganisation(request: DeepPartial<Organisation>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
}

export class OrganisationServiceClientImpl implements OrganisationService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getAllOrganisations = this.getAllOrganisations.bind(this);
    this.updateOrganisation = this.updateOrganisation.bind(this);
  }

  getAllOrganisations(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetAllOrganisationsResponse> {
    return this.rpc.unary(OrganisationServiceGetAllOrganisationsDesc, EmptyRequest.fromPartial(request), metadata);
  }

  updateOrganisation(request: DeepPartial<Organisation>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(OrganisationServiceUpdateOrganisationDesc, Organisation.fromPartial(request), metadata);
  }
}

export const OrganisationServiceDesc = { serviceName: "services.organisations.OrganisationService" };

export const OrganisationServiceGetAllOrganisationsDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllOrganisations",
  service: OrganisationServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetAllOrganisationsResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const OrganisationServiceUpdateOrganisationDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateOrganisation",
  service: OrganisationServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Organisation.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
